import React, {useEffect, useState} from "react";
import {RiPrinterLine, RiRefreshLine} from "react-icons/ri";
import {TOTO_PRICE_LIST} from "../constants/component_constants";
import neverLandGameData from "../utils/NeverLandGameData";
import {SEND_TOTO_WDL_PRINT_INFO_API} from "../constants/api_constants";
import {ModalHandler, OpenModalHandle} from "./modal/ModalHandler";
import {accountInfo} from "../constants/constants";
import {getFetcherEB} from "../utils/fetcher_eb";


const TotoCartSidebar = ({totoGameList, selectedSubMenuOption, gameStatus, categoryOption, getRoundNumber}) => {
  const [priceList, setPriceList] = useState(TOTO_PRICE_LIST);
  const [isShowPriceList, setIsShowPriceList] = useState(false);  // 셀렉트박스 메뉴보이기
  const [selectedPrice, setSelectedPrice] = useState(neverLandGameData.totalCombinations * 1000); // 투표 금액
  const [selectedPriceOption, setSelectedPriceOption] = useState(TOTO_PRICE_LIST[0]); // 선택한 금액 옵션
  const [refreshDate, setRefreshDate] = useState("0");
  const currentTime = new Date();
  const OpenModal = OpenModalHandle.create();
  const updateUI = () => {
    let newRefreshDate = new Date() + ".00";
    if (newRefreshDate === refreshDate) {
      newRefreshDate += "0";
    }
    setRefreshDate(newRefreshDate);
  }
  const reloadSelectedBoxList = () => {
    handleSelectBoxList(false);
    updateUI();
  }

  useEffect(() => {
    neverLandGameData.addOnTotoCombinationChangedHandler(reloadSelectedBoxList);
    return () => {
      // 언마운트 시
      onClear();
      neverLandGameData.removeOnTotoCombinationChangedHandler(reloadSelectedBoxList);
    };
  }, []);

  // 조합이 변경되면 자동 금액 선택으로 리셋
  useEffect(() => {
    setSelectedPriceOption(TOTO_PRICE_LIST[0]);
    setSelectedPrice(neverLandGameData.totalCombinations * 1000);
  }, [neverLandGameData.totalCombinations]);

  useEffect(() => {
    if (selectedPriceOption.value === 0) {
      // 자동 금액 선택일 때 = 조합수 * 1000
      setSelectedPrice(neverLandGameData.totalCombinations * 1000);
    } else {
      // 셀렉트박스에서 금액을 선택했을 때 = 선택한 금액
      setSelectedPrice(selectedPriceOption.value);
    }
  }, [selectedPriceOption.value, neverLandGameData.totalCombinations]);

  const handleSelectPrice = (value) => {
    const selected = TOTO_PRICE_LIST.find(price => price.value === value);
    setSelectedPriceOption(selected);

    if (value === 0) {
      setSelectedPrice(neverLandGameData.totalCombinations * 1000);
    } else {
      setSelectedPrice(value);
    }

    setIsShowPriceList(false);
  };

  const handleSelectBoxList = (showList) => {
    // 금액 선택 셀렉트박스 클릭 이벤트
    if (isShowPriceList) {
      // 열려있으면 닫기
      if (showList) {
        setIsShowPriceList(false);
      }
    } else {
      // 조합에 따라서 선택 가능한 금액 리스트만 띄우기
      const availablePrices = neverLandGameData.findMatchingPrice();

      setPriceList(availablePrices);  // 셀렉트 메뉴 업데이트
      // setSelectedPriceOption(availablePrices[0]);
      if (showList) {
        setIsShowPriceList(true);
      }
    }
  }

  const getClosingTime = () => {
    // 발매 마감시간
    if (!totoGameList || totoGameList.length === 0) return '';

    const closingDate = totoGameList[0].closingDate;
    const endDate = closingDate.split(' ~ ')[1];

    const dateStr = endDate.substring(5, 10);
    const timeStr = endDate.substring(11);

    // 요일 구하기
    const year = endDate.substring(0, 4);
    const date = new Date(`${year}-${dateStr.replace('-', '-')}`);

    const weekdays = ['일', '월', '화', '수', '목', '금', '토'];
    const dayOfWeek = weekdays[date.getDay()];

    return `${dateStr}(${dayOfWeek}) ${timeStr}`;
  };

  function getCategoryTitle() {
    const name = selectedSubMenuOption.name;

    if (name.length < 10)
      return name;

    let tokens = name.split(' ');
    if (tokens.length > 3)
      return tokens[1] + ' ' + tokens[3];
    return name.substring(0, 9) + '...';
  }


  // <-- 인쇄하기 -->
  function printTickets() {
    const _selectTotoData = neverLandGameData._totoSelectedGames;
    const _availablePrices = neverLandGameData.findMatchingPrice();
    // 투표액이 천원 && 조합 수가 1 또는 0 => 단식
    const _isSingleGame = selectedPrice === 1000 && neverLandGameData.totalCombinations <= 1;
    // 투표액이 천원 && 14경기 미만 선택일때 => 단식 자동
    const _isAutoMode = selectedPrice === 1000 && _selectTotoData.length < 14;
    const _combi = neverLandGameData.calculateCombination();

    // <- MEMO : 출력 불가 조건 ->
    // // 선택 가능한 금액이 없을 때
    // if (_availablePrices.length === 0) {
    //   OpenModal.openWarningModal('출력 불가', '선택하신 조합으로는 출력할 수 없습니다.');
    //   return;
    // }


    // 2개 또는 3개 조합이 있는데 금액이 1000원일 때(금액 선택 안했을 때)
    if ((_combi[2] > 0 || _combi[3] > 0) && selectedPrice === 1000) {
      OpenModal.openWarningModal('출력 불가', '복식에서 1,000원은 불가능합니다.\n 금액을 선택 해 주세요.');
      return;
    }

    let print_data = {
      pages: [{
        page: 1,
        customText: "-", // 출력시 식별
        printDefaultText: true, // customText on/off
        "단식": _isSingleGame ? [
          {
            pick: _selectTotoData,
            auto: _isAutoMode
          }
        ] : [],
        "복식": _isSingleGame ? {} : {
          pick: _selectTotoData,
          auto: {
            // 목록에 있는 금액을 선택 했을 때 use:true
            use: selectedPriceOption.value !== 0,
            amount: selectedPriceOption.value === 0 ? [] : [selectedPrice]
          }
        }
      }],
      pageCount: 1
    };

    if (window.chrome && window.chrome.webview && window.chrome.webview.postMessage) {
      let msg = JSON.stringify({data: print_data, command: 'request_print', ticket_type: 'toto(soccer)'});
      window.chrome.webview.postMessage(msg);
    }
    sendPrintInfo(print_data);
    onClear();
  }

  const sendPrintInfo = (print_data) => {
    // 출력할때 정보 백엔드 넘겨주기
    let _send_toto_wdl_data = [{
      printDateTime: currentTime.toISOString(), // 요청시간
      printRoundNumber: getRoundNumber, // 회차 번호
      itemPickNameEnum: '승무패',  // 픽이름
      printMoney: selectedPrice,  // 투표 금액
      storeCodeName: accountInfo.storeCode(), // 지점 코드
      machineCodeName: accountInfo.deviceCode(), // 기기 코드
      totoGameCategory: categoryOption.toUpperCase(), // 경기 카테고리
      wdlPrintRequestDTO: print_data,
    }]

    getFetcherEB().post(SEND_TOTO_WDL_PRINT_INFO_API, {wdlPrintDTOList: _send_toto_wdl_data})
      .then(res => {
        const {responseResultCode, responseResultDescription, storeList} = res.data;
        if (responseResultCode === "STORE_LIST_GET_SUCCESS") {
        } else {
          console.log(responseResultDescription);
        }
      }).catch((err) => {
      console.log(err);
    });
  }

  const onClear = () => {
    // 경기 선택 초기화
    neverLandGameData.clearTotoSelection();
    handleSelectPrice(0);
  }


  return (
    <div
      className="w-full h-full flex flex-col bg-gray-100 flex-grow p-3 rounded-2xl shadow-md border border-gray-200 justify-between">
      <ModalHandler initModalHandle={OpenModal}/>

      {/* <-- 상단 상태 표시 영역 --> */}
      <div className="pb-2 flex flex-row items-center justify-around">
        <p className="font-bold text-lg"> {getCategoryTitle()} </p>

        <span className={`inline-flex items-center px-1 py-1 rounded-md text-sm ring-1 font-bold ${
          gameStatus === '발매중' ? 'bg-blue-100 text-blue-700 ring-blue-600 px-2' :
            gameStatus === '발매마감' ? 'bg-yellow-100 text-yellow-700 ring-yellow-600' :
              gameStatus === '경기종료' ? 'bg-red-100 text-red-700 ring-red-600' :
                'bg-gray-100 text-gray-700 ring-gray-600'
        }`}>
          {gameStatus}
          </span>

        <p className="font-bold text-sm text-gray-600"> {getClosingTime()} 마감 </p>
      </div>

      {gameStatus === '발매중' &&
        <div className="flex flex-col min-h-[25rem] justify-between">
          <div className="flex flex-col">
            <button className="w-full button-style bg-lime-300 text-black flex flex-row justify-center items-center"
                    onClick={onClear}
            >
              <RiRefreshLine className="w-5 h-auto mr-2"/>
              경기 선택 초기화
            </button>

            {/*<div className="w-full h-[7rem]">*/}
            {/*  <div className="my-3 py-2 px-3 bg-yellow-200 rounded-lg shadow-md flex flex-row justify-between font-bold">*/}
            {/*    <p>{selectedPrice.toLocaleString()} 원</p>*/}
            {/*    <button onClick={() => {*/}
            {/*      setSelectedPrice(neverLandGameData.totalCombinations * 1000);*/}
            {/*      setSelectedPriceOption(TOTO_PRICE_LIST[0]);*/}
            {/*    }}*/}
            {/*            className="bg-red-600 rounded">*/}
            {/*      <RiCloseLine className="h-6 w-auto text-white"/>*/}
            {/*    </button>*/}
            {/*  </div>*/}
            {/*</div>*/}
          </div>

          <div>
            <div className="flex flex-row justify-between">
              {/* <-- 금액 셀렉트 박스 --> */}
              <div className="relative w-full">
                <button
                  type="button"
                  key={selectedPrice}
                  onClick={() => handleSelectBoxList(true)}
                  className="w-full px-4 py-2 text-left border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition bg-white hover:bg-gray-50 flex items-center justify-between"
                >
                  <span className="text-gray-900">{selectedPriceOption?.name}</span>
                  <svg
                    className={`w-5 h-5 text-gray-400 transition-transform ${isShowPriceList ? 'rotate-180' : ''}`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7"/>
                  </svg>
                </button>

                {isShowPriceList && (
                  <div
                    className="absolute z-10 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg overflow-hidden">
                    {priceList?.map((item) => (
                      <button
                        key={item.value}
                        type="button"
                        onClick={() => handleSelectPrice(item.value)}
                        className={`w-full px-4 py-3 text-left hover:bg-blue-50 transition ${
                          selectedPriceOption.value === item.value
                            ? 'bg-blue-50 text-blue-600 font-medium'
                            : 'text-gray-900'
                        }`}
                      >
                        {item.name}
                        {selectedPriceOption.value === item.value && (
                          <svg className="inline w-5 h-5 ml-2" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd"
                                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                  clipRule="evenodd"/>
                          </svg>
                        )}
                      </button>
                    ))}
                  </div>
                )}
              </div>

              {/* <-- 자동 선택 버튼 --> */}
              {/*<button*/}
              {/*  onClick={() => setIsAutoMode(prevState => !prevState)}*/}
              {/*  type="button"*/}
              {/*  className={`button-style w-1/2 ml-4 transition-all font-bold ${*/}
              {/*    isAutoMode*/}
              {/*      ? 'bg-blue-600 text-white'*/}
              {/*      : 'bg-white text-gray-800 border border-gray-300'*/}
              {/*  }`}*/}
              {/*>*/}
              {/*  {isAutoMode ? '자동 선택 모드' : '자동 선택'}*/}
              {/*</button>*/}
            </div>

            {/* <-- 조합 & 금액 안내 영역 --> */}
            <div className="my-3 p-4 bg-blue-50 rounded-lg ring-1 ring-blue-500 text-gray-600">
              <div className="flex flex-row justify-between items-center">
                <p>조합 수 :</p>
                <p className="text-lg font-bold text-blue-600"> {neverLandGameData.totalCombinations} 조합</p>
              </div>

              <div className="flex flex-row justify-between items-center">
                <p>개별 투표액 :</p>
                <p className="text-lg font-bold text-blue-600"> 1,000 원</p>
              </div>

              <div className="flex flex-row justify-between items-center">
                <p>총 투표액 :</p>
                <p className={`text-lg font-bold ${selectedPrice > 100000 ? 'text-red-600' : 'text-blue-600'}`}>
                  {selectedPrice.toLocaleString()} 원
                </p>
              </div>

              <div className="my-3 border-t border-gray-400"/>

              <div className="flex flex-row justify-between items-center">
                <p>구매 가능액 :</p>
                <p> 100,000원</p>
              </div>
            </div>

            {/* <-- 출력 버튼 --> */}
            <button
              onClick={() => {
                // selectAllTickets();
                printTickets(neverLandGameData.ticketData);
              }}
              disabled={(neverLandGameData.totalCombinations === 0 && selectedPrice === 0) || selectedPrice > 100000}
              type="button"
              className="button-style bg-blue-600 disabled:bg-gray-400 text-white w-full py-2 flex flex-row justify-center items-center"
            >
              <RiPrinterLine className="w-5 h-auto text-white mr-2"/>
              출력하기
            </button>
          </div>
        </div>
      }
    </div>
  );
}
export default TotoCartSidebar;